import { createSlice } from '@reduxjs/toolkit';

// Slice
const slice = createSlice({
  name: 'purchaseOrder',
  initialState: {
    purchaseOrder: null,
  },
  reducers: {
    setPurchaseOrder: (state, { payload }) => {
      state.purchaseOrder = payload;
    },
  },
});

// Actions
export const { setPurchaseOrder } = slice.actions;

export default slice.reducer;